export default {"src":"/_next/static/media/image-season-avatar-button.4d3f32d9.svg","height":43,"width":200,"blurWidth":0,"blurHeight":0};